import type { Company } from "@domain/CRM/company";
import type { Job } from "@domain/CRM/job";
import type { IJobs } from "@ports/jobs/IJobs";

export interface JobsListUseCasesDeps {
	jobsApi: IJobs;
}

/**
 * Read path for the jobs list (JobsDashboardTable). Thin pass-through to the
 * `IJobs` port; no business logic. Exists so VMs depend on a use case rather
 * than `API.Data.Jobs` directly — swap-in test/CLI implementations just supply
 * the port.
 */
export interface JobsListUseCases {
	loadByCompany(company: Company, branchNames?: string[]): Promise<Job[]>;
	loadUnscheduled(): Promise<Job[]>;
}

export function loadByCompany(deps: JobsListUseCasesDeps, company: Company, branchNames?: string[]): Promise<Job[]> {
	return deps.jobsApi.getByCompany(company, branchNames);
}

export function loadUnscheduled(deps: JobsListUseCasesDeps): Promise<Job[]> {
	return deps.jobsApi.getUnscheduled();
}

export function makeJobsListUseCases(deps: JobsListUseCasesDeps): JobsListUseCases {
	return {
		loadByCompany: (company, branchNames) => loadByCompany(deps, company, branchNames),
		loadUnscheduled: () => loadUnscheduled(deps),
	};
}
